import api from '@/utils/api';
import dts from 'highlight.js/lib/languages/dts';

const { baseApi } = window.GlobalConfig;

export const getIncomeTargetTree = data => {
    return api.get(`${baseApi}/incomeTarget/getIncomeTargetTree/${data.year}`);
};

export const getIncomeTargetTreeByCurrentUserRecursive = data => {
    return api.get(`${baseApi}/incomeTarget/getIncomeTargetTreeByCurrentUserRecursive/${data.year}`);
};

export const saveIncomeTargetBatch = data => {
    return api.post(`${baseApi}/incomeTarget/saveIncomeTargetBatch`, data);
};

export const saveIncomeCurrentBatch = data => {
    return api.post(`${baseApi}/incomeTarget/saveIncomeTargetRegionBatch`, data);
};

// 预算管理

export const queryIncomeBudget = data => {
    return api.post(`${baseApi}/incomeBudget/getIncomeBudgetPage`, data);
};

export const getBudgetDetail = data => {
    return api.post(`${baseApi}`, data);
};

export const saveRemark = data => {
    return api.post(`${baseApi}`, data);
};

export const submitBudget = data => {
    return api.post(`${baseApi}`, data);
};

// 实际收入

export const queryIncomeReality = data => {
    return api.post(`${baseApi}/incomeActual/getIncomeActualByMedicalItemPage`, data);
};

export const queryIncomeRealityType = data => {
    return api.post(`${baseApi}/incomeActual/getIncomeActualByBusinessTypePage`, data);
};

export const queryIncomeDetailByType = data => {
    return api.post(`${baseApi}/incomeActual/getIncomeActualInfo`, data);
};

export const queryIncomeTotal = data => {
    return api.post(`${baseApi}/incomeActual/getIncomeActualByCustomerPage`, data);
};

// 收入预测

export const queryForecast = data => {
    return api.post(`${baseApi}/incomeForecastBase/getIncomeForecastSummaryPage`, data);
};

export const queryForecastEdit = data => {
    return api.post(`${baseApi}/incomeForecastBase/getIncomeForecastSummary2EditPage`, data);
};

export const queryForecastDetail = data => {
    return api.post(`${baseApi}/incomeForecastBase/getIncomeForecastInfo`, data);
};

export const editForecast = data => {
    return api.post(`${baseApi}/incomeForecastBase/saveIncomeForecast4MonthByCustomer`, data);
};

export const QueryForecastNot = data => {
    return api.post(`${baseApi}/incomeForecastBase/getNotFillIncomeForecastCustomerPage`, data);
};

// 结算管理

export const QuerySettlementPage = data => {
    return api.post(`${baseApi}/incomeSettle/getIncomeSettlePage`, data);
};

// 开发客户预测

export const QueryDevelopBudget = data => {
    return api.post(`${baseApi}`, data);
};

export const QueryTarget = ({ year }) => {
    return api.get(`${baseApi}/incomeTargetUser/getIncomeTargetUser4CurrentUser/${year}`);
};

export const UpdateSettlementForecast = data => {
    // return api.post(`${baseApi}/incomeForecast/updateIncomeForecastBaseBySettle`, data);
    return api.post(`${baseApi}/incomeForecast/updateIncomeForecastBaseByActual`, data);
};

// 个人指标

export const QueryPersonal = data => {
    // return api.post(`${baseApi}/incomeTargetUserExt/getIncomeTargetUserExtPage`, data);
    return api.post(`/incomeTargetUserMonth/getIncomeTargetUserMonthPage`, data);
};

export const AssginPersonal = data => {
    // return api.post(`${baseApi}/incomeTargetUserExt/saveIncomeTargetUserExtByPercent`, data);
    return api.post(`${baseApi}/incomeTargetUserMonth/saveIncomeTargetUserMonthByPercent`, data);
};

export const QueryPersonal2 = data => {
    return api.post(`${baseApi}/incomeTargetUserDirect/getIncomeTargetUserDirectPage`, data);
};

// 个人指标存量编辑

export const QueryEditStockTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/getIncomeTargetCustomerPrepare4PersonPage`, data);
};

export const QueryViewTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/getIncomeTargetCustomerPrepare4Person4CheckPage`, data);
};

export const SaveStockTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/saveIncomeTargetCustomerPrepare4Person`, data);
};

export const QueryCompanyMarkTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/getIncomeTargetCustomerPrepare4CompanyPage`, data);
};

export const SaveCompanyMarkTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/saveIncomeTargetCustomerPrepare4Company`, data);
};

export const SaveTotalMarkTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/saveIncomeTargetCustomerPrepare4Result`, data);
};

export const SaveAdjustRule = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/updatePrepare4ResultByRule`, data);
};

export const SaveMarkTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/saveIncomeTargetCustomerPrepare`, data);
};

export const QueryManageTarget = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/getIncomeTargetCustomerPrepare4ChargePage`, data);
};

export const SubmitPrepare = data => {
    return api.post(`${baseApi}/incomeTargetCustomerPrepare/submitIncomeTargetCustomerPrepare`, data);
};

// export const SubmitManagePrepare = data => {
//     return api.post(`${baseApi}`, data);
// };

export const SaveManageTarget = data => {
    return api.post(`${baseApi}`, data);
};

export const QueryBaseCustomer = data => {
    return api.post(`${baseApi}/customer/getCustomerListPage`, data);
};

export const ViewItemsByCustomerId = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRiseBaseByCustomerIdPage`, data);
};

export const SaveItemsTarget = data => {
    return api.post(`${baseApi}/incomeRiseBase/saveIncomeRiseBase`, data);
};

export const AdjustItemsRule = data => {
    return api.post(`${baseApi}/customerMedicalItemRel/updateBaseByRule`, data);
};

export const QueryUpUser = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4UserPageVo`, data);
};

export const QueryCustomerFinance = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4CustomerByUserPage`, data);
};

export const QueryItemsFinance = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4ItemByCustomerPage`, data);
};

export const QueryCustomerSettlement = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4Customer4SettleByUserPage`, data);
};

export const QueryItemsSettlement = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4Item4SettleByCustomerPage`, data);
};

export const QuerySettlementUser = data => {
    return api.post(`${baseApi}/incomeRiseBase/getIncomeRise4User4SettlePageVo`, data);
};

// 新的预估接口

export const QueryForecastByMonth = data => {
    return api.post(`${baseApi}/incomeForecastBase/getIncomeForecastBaseInfo`, data);
};

export const QueryViewItemsForecast = data => {
    return api.post(`${baseApi}/incomeForecastBase/getIncomeForecastIncreaseItemInfoList`, data);
};

export const SubmitForecastNew = data => {
    return api.post(`${baseApi}`, data);
};

export const QueryMedicalItems = data => {
    return api.post(`${baseApi}/incomeForecastBase/getMedicalItemRelListWithIncome4Customer`, data);
};

//

export const QueryTrackCustomer = data => {
    return api.post(`${baseApi}/incomeForecastBase/getForecastTracking4CustomerPage`, data);
};

export const QueryTrackMedical = data => {
    return api.post(`${baseApi}/incomeForecastBase/getForecastTracking4ItemPage`, data);
};

export const QueryMedicalDocts = data => {
    return api.post(`${baseApi}/employee/getCustomerEmployeeBySettlePage`, data);
};

export const QueryTrend = data => {
    return api.post(`${baseApi}/incomeSettle/getIncomeSettleByEmployee`, data);
};

// 联系人维度

export const QuerySettleByDoctor = data => {
    return api.post(`${baseApi}/incomeSettle/getSettleIncome4EmployeePage`, data);
};

// 市场预测
export const QueryUpData = data => {
    return api.post(`/incomeForecastIncreaseItem/getIncomeForecastIncreaseList4CustomerPage`, data);
};

// 市场预估保存
export const SaveUpForecast = data => {
    return api.post(`/incomeForecastIncreaseItem/saveIncomeForecastIncreaseList4Customer`, data);
};

// 未分配客户预估填写

export const MarkNoAssginForecast = data => {
    return api.post(``, data);
};

// 查询未分配客户

export const QueryNoAssginForecast = data => {
    return api.post(`/incomeForecastBase/getIncomeForecastSummary2EditNotAssignCustomerPage`, data);
};

export const QueryIncomeActualFinishArea = data => {
    return api.post(`/incomeActual/getIncomeActualFinishAnalysis4Area`, data);
};

export const QueryIncomeActualFinishUser = data => {
    return api.post(`/incomeActual/getIncomeActualFinishAnalysis4UserPage`, data);
};

export const QueryIncomeActualFinishCustomer = data => {
    return api.post(`/incomeActual/getIncomeActualFinishAnalysis4CustomerPage`, data);
};

export const QueryOffsetAreaData = data => {
    return api.post(`/incomeActual/getIncomeActualForecastGap4Area`, data);
};

export const QueryOffsetUserData = data => {
    return api.post(`/incomeActual/getIncomeActualForecastGap4UserPage`, data);
};

export const QueryOffsetCustomerData = data => {
    return api.post(`/incomeActual/getIncomeActualForecastGap4CustomerPage`, data);
};

// 同环比数据
export const QueryIncomeAreaCompare = data => {
    return api.post(``, data);
};

export const QueryIncomeUserCompare = data => {
    return api.post(``, data);
};

export const QueryIncomeCustomerCompare = data => {
    return api.post(``, data);
};
